<template>
    <div>
        <el-button type="primary">返回</el-button>
        <iframe :src="iframeSrc" height="1000" width="1700"></iframe>
    </div>
</template>
<script>
export default {
    data(){
        return {
            iframeSrc:'http://172.16.6.188:8080/#/index?town=all'
        }
    }
}
</script>
